import { render, staticRenderFns } from "./component.phone-code.vue?vue&type=template&id=1959dc99&scoped=true"
import script from "./component.phone-code.vue?vue&type=script&lang=js"
export * from "./component.phone-code.vue?vue&type=script&lang=js"
import style0 from "./component.phone-code.vue?vue&type=style&index=0&id=1959dc99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959dc99",
  null
  
)

export default component.exports